(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["portfolio"] && !Shopify.designMode) return;
  try {
    
  (function () {

    /* ── Scatter position formula ────────────────────────────────────────
       Deterministic: same seed → same layout every time.
       Different cycle → completely different scatter arrangement.
    ── */
    function scatter(i, cycle) {
      var h = i * 47 + cycle * 83;
      return {
        left:     3  + (h * 137 % 77),  /* 3 – 79 % */
        top:      5  + (h * 53  % 40),  /* 5 – 44 % */
        rotation: (h * 17  % 30) - 15,  /* -15 – +14 ° */
        width:    15 + (h * 11  % 8),   /* 15 – 22 vw */
        zIndex:   1  + (h * 7   % 6)    /* 1 – 6 */
      };
    }

    /* Apply scatter positions to slides already rendered in the DOM */
    function applyScatter(scene, cycle) {
      scene.querySelectorAll('.portfolio-carousel__slide').forEach(function (slide, i) {
        var p = scatter(i, cycle);
        slide.style.left   = p.left  + '%';
        slide.style.top    = p.top   + '%';
        slide.style.width  = p.width + 'vw';
        slide.style.zIndex = p.zIndex;
        slide.style.setProperty('--r', p.rotation + 'deg');
      });
    }

    function init() {
      var sceneA = document.getElementById('pc-scene-a');
      var sceneB = document.getElementById('pc-scene-b');
      if (!sceneA || !sceneB) return;

      if (sceneA.querySelectorAll('.portfolio-carousel__slide').length === 0) return;

      var cycle = 0;

      /* Apply initial scatter and position scenes */
      applyScatter(sceneA, cycle);
      sceneA.style.transform = 'translateX(0)';

      applyScatter(sceneB, cycle + 1);
      sceneB.style.transition = 'none';
      sceneB.style.transform  = 'translateX(-100%)';

      var current = sceneA;
      var next    = sceneB;

      /* Auto-advance every 3 s */
      setInterval(function () {
        cycle++;

        /* Re-scatter the waiting scene with the new cycle */
        applyScatter(next, cycle);

        /* Snap it off-screen left instantly (no transition) */
        next.style.transition = 'none';
        next.style.transform  = 'translateX(-100%)';

        /* Two rAF calls ensure the browser has committed the snap
           before we re-enable transitions and start animating */
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            current.style.transition = '';
            next.style.transition    = '';

            /* Current exits right; next enters from left */
            current.style.transform = 'translateX(100%)';
            next.style.transform    = 'translateX(0)';

            var tmp = current;
            current = next;
            next    = tmp;
          });
        });
      }, 3000);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scattered-images"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function scatter(i) {
      var h = i * 47;
      return {
        left:     5  + (h * 137 % 75),
        top:      5  + (h * 53  % 70),
        rotation: (h * 17  % 30) - 15,
        width:    18 + (h * 11  % 12),
        zIndex:   1  + (h * 7   % 9)
      };
    }

    function applyScatter(canvas) {
      var items = canvas.querySelectorAll('.scattered__item');
      items.forEach(function (item, i) {
        var p = scatter(i);
        item.style.left   = p.left  + '%';
        item.style.top    = p.top   + '%';
        item.style.width  = p.width + 'vw';
        item.style.zIndex = p.zIndex;
        item.style.setProperty('--scatter-r', p.rotation + 'deg');
      });
    }

    function init() {
      document.querySelectorAll('[id^="scattered-canvas-"]').forEach(applyScatter);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
